import styled from '@emotion/styled'

export const StyleCalenderHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyleActionBtn = styled.button`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 8px;
  background: none;
  padding: 10px 15px;
`

export const StyleWeekDaysWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  flex-flow: row wrap;
`

export const StyleWeekDayItem = styled.div`
  width: calc(100% / 7);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.text100};
`

export const StyleDatesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  padding: 16px 0;
`

export const StyleDateItem = styled.div<any>`
  text-align: center;
  padding: 8px;
  border-radius: 6px;
  font-weight: 500;
  color: ${(props: any) =>
    props.theme.colors[!!props?.isActive ? 'secondary' : 'text']};
  background: ${(props: any) =>
    props.theme.colors[!!props?.isActive ? 'primary100' : 'transparent']};
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`
